module.exports = __webpack_public_path__ + "img/sjs-6.48d9b9c2.png";